<template>
  <div class="maintenance-notification" v-if="maintenance.isMaintenanceEnabled">
    <img src="@/assets/branding/logo2.svg" class="maintenance-notification__logo" />
    <p class="maintenance-notification__info">
      <template v-if="maintenance.maintenanceMessage">
        {{ maintenance.maintenanceMessage }}
      </template>
      <template v-else> We are currently undergoing scheduled maintenance. </template>
    </p>
  </div>
</template>
<script src="./maintenance-notification.js"></script>
<style src="./maintenance-notification.scss" lang="scss"></style>
